import { MissingAppointmentsApi } from "../../Api/MissingAppointmentsApi";
import {Dispatch, useEffect, useMemo} from "react";
import { ServiceContainerDto } from "../../../../Api/Model/ServiceContainerDto.csharp";
import { FormFields, FormReducer } from "../Helpers/formTypes";

const api = new MissingAppointmentsApi();

export const useMissingAppointments = (
  service: ServiceContainerDto,
  showRelatedServicesMap: Map<number, boolean>,
  dispatch: Dispatch<any>
) => {
  const relatedServiceIds = useMemo(() => {
    const ids: number[] = [];

    for (const [key, showRelatedServices] of showRelatedServicesMap) {
      if (showRelatedServices) {
        ids.unshift(key);
      }
    }

    return ids;
  }, [showRelatedServicesMap]);
  
  useEffect(() => {
    (async () => {
      if (!service?.id) return;
      const missing = await api.get(service.id, relatedServiceIds ?? []);
      if (!!missing) {
        dispatch({
          type: FormReducer.update,
          field: FormFields.missingAppointments,
          payload: missing,
        });
      }
    })();
  }, [service, relatedServiceIds]);
};
